import modelMap from '@/builder/model-map'

export const accountFormLabelInput = {
    name: 'accountFormLabels',
    type: 'reference',
    model: modelMap.accountFormLabels,
    required: true,
    helperText:
        'An account form drawer is triggered in this componenet if the user is not signed in. Select the account form labels to use'
}
